import { render, staticRenderFns } from "./modalEntregaCompleta.vue?vue&type=template&id=fbad115a&"
import script from "./modalEntregaCompleta.vue?vue&type=script&lang=js&"
export * from "./modalEntregaCompleta.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports